// Arquivo para verificação das variáveis de ambiente
export const debugEnvironmentVariables = () => {
  if (!process.env.REACT_APP_SUPABASE_URL || !process.env.REACT_APP_SUPABASE_ANON_KEY) {
    return false
  }
  
  if (process.env.REACT_APP_SUPABASE_URL.includes('your-project')) {
    return false
  }
  
  return true
}
